export const pageLocales = {
	blog: ['en-US', 'en-GB', 'en-AU'],
	'articles-all': ['en-US', 'en-GB', 'en-AU'],
	events: ['en-US', 'en-GB', 'en-AU'],
	'make-it-big': ['en-US', 'en-GB', 'en-AU'],
	apps: ['en-US', 'en-GB', 'en-AU'],
	themes: ['en-US', 'en-GB', 'en-AU'],
	'case-study': ['en-US', 'en-GB', 'en-AU', 'it-IT', 'nl-NL', 'fr-FR', 'es-ES', 'de-DE', 'es-MX'],
	resources: [
		'en-US',
		'en-GB',
		'en-AU',
		'en-SG',
		'it-IT',
		'nl-NL',
		'fr-FR',
		'es-ES',
		'de-DE',
		'es-MX',
		'sv-SE',
		'da-DK',
		'nb-NO',
		'de-AT'
	],
	glossary: ['en-US', 'en-GB', 'en-AU'],
	'404': ['en-US', 'en-GB', 'en-AU']
}
